<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <el-form class="search" label-suffix="：" size="mini" :model="search">
          <el-form-item label="权限类型">  
            <el-select v-model="search.type" clearable placeholder="请选择" class="w200" >
              <el-option :value="1" label="市场"></el-option>
              <el-option :value="2" label="店铺"></el-option>
              <el-option :value="3" label="员工"></el-option>
              <el-option :value="4" label="个人" ></el-option>
            </el-select>
          </el-form-item> 
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <el-button type="primary" round class="mb10" size="mini" @click="showAddDialog">添加常用筛选</el-button>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            v-loading="loading"
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="录入时间" width="150" prop="create_time" fixed="left"/>
            <ElTableColumn label="名称" prop="name" width="160" fixed="left"/>
            <ElTableColumn label="筛选条件">
              <template slot-scope="{ row }">
                <el-popover
                  placement="bottom"
                  title="筛选条件展示"
                  width="500"
                  trigger="click"
                  :content="row.remark || '-'">
                  <div slot="reference" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"> 
                    {{ row.remark || '-' }}
                  </div>
                </el-popover>
              </template>
            </ElTableColumn>
            <ElTableColumn label="权限类型" prop="type" width="240">
              <template slot-scope="{ row }">
                <span>
                  {{ row.type == 1 ? '市场' : row.type == 2 ? '店铺' : row.type == 3 ? '员工' : '个人' }}
                  <template v-if="row.type === 1 && row.market_names && row.market_names.length > 0">
                    （{{ row.market_names.join('，') }}）
                  </template>
                  <template v-if="row.type === 2 && row.shop_names && row.shop_names.length > 0">
                    （{{ row.shop_names.join('，') }}）
                  </template>
                  <template v-if="row.type === 3 && row.person_names && row.person_names.length > 0">
                    （{{ row.person_names.join('，') }}）
                  </template>
                </span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="分群人数" prop="last_count" fixed="left" width="90"/>
            <ElTableColumn label="创建人" prop="admin_name" fixed="left" width="90"/>
            <ElTableColumn label="操作" fixed="right" width="160">
              <template slot-scope="{ row }">

                <span class="theme" @click="tapBtn('查看',row)">查 看</span>
                <span class="theme" @click="getExport(row)">导 出</span>
                <el-popconfirm title="确定要删除该分群嘛？" @confirm="deleteTag(row)" v-if="row.admin_id == userInfo.id || userInfo.group_id == 96 || [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
                  <span class="theme" slot="reference">删 除</span>
                </el-popconfirm>
              </template>
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-drawer
      title="新增筛选条件"
      :visible.sync="addDialogVisible"
      direction="rtl"
      size="90%"
      :wrapper-closable="false"
      :before-close="handleDrawerClose"
    >
      <div class="drawer-content">
        <el-form
          ref="filterFormRef"
          :model="filterForm"
          label-position="left"
          label-suffix="："
          label-width="140px"
          size="mini"
        >
          <div class="group">基础信息</div>
          <div class="form-container">
            <el-form-item label="创建时间" class="form-item">
              <el-date-picker
                v-model="filterForm.create_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="w220"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="客户姓名" class="form-item">
              <el-input
                v-model="filterForm.customer_name"
                placeholder="请输入客户姓名"
                class="w220"
                clearable
              />
            </el-form-item>
            <el-form-item label="手机号" class="form-item">
              <el-input
                v-model="filterForm.telephone"
                placeholder="请输入手机号"
                class="w220"
                clearable
              />
            </el-form-item>
            <el-form-item label="金蝶编码" class="form-item">
              <el-input
                v-model="filterForm.king_no"
                placeholder="请输入金蝶编码"
                class="w220"
                clearable
              />
            </el-form-item>
            <el-form-item label="性别" class="form-item">
              <el-select v-model="filterForm.sex" placeholder="请选择性别" class="w220" clearable>
                <el-option label="未知" :value="0"></el-option>
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年龄区间" class="form-item">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_age"
                  placeholder="最小年龄"
                  class="w100"
                  type="number"
                  min="0"
                  max="200"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_age"
                  placeholder="最大年龄"
                  class="w100"
                  type="number"
                  min="0"
                  max="200"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="渠道来源" class="form-item">
              <el-select
                v-model="filterForm.source_id"
                placeholder="请选择渠道来源"
                class="w220"
                multiple
                clearable
                filterable
                collapse-tags
              >
                <el-option
                  v-for="item in options.sourceIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="到店时间" class="form-item">
              <el-date-picker
                v-model="filterForm.entry_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="w220"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="疑难级别" class="form-item">
              <el-select v-model="filterForm.difficulty_level" multiple collapse-tags clearable class="w220">
                <el-option
                  v-for="item in options.difficultyLevelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="疤痕类型" class="form-item">
              <el-cascader  
                v-model="filterForm.scar_id"
                placeholder="请选择疤痕类型"
                collapse-tags
                class="w220" 
                :options="options.scarTypeList"    
                :props="{   
                  value: 'id',
                  label: 'label',
                  children: 'children', 
                  multiple: true,
                  emitPath: false
                }" 
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="修复进展" class="form-item">
              <el-select
                v-model="filterForm.repair_progress"
                placeholder="请选择修复进展"
                class="w220"
                clearable
                multiple 
                collapse-tags
              >
                <el-option
                  v-for="item in options.repairProgressList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会员等级" class="form-item">
              <el-select
                v-model="filterForm.membership_leve"
                placeholder="请选择会员等级"
                class="w220"
                clearable
              >
                <el-option
                  v-for="item in options.membershipLeveList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属客服" class="form-item">
              <el-select
                v-model="filterForm.creator_id"
                placeholder="请选择所属客服"
                class="w220"
                clearable
                remote
                filterable
                multiple 
                collapse-tags
              >
                <el-option
                  v-for="item in options.adminList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="所属护理师" class="form-item">
              <el-select
                v-model="filterForm.nurse_id"
                placeholder="请输入并选择所属护理师"
                class="w220"
                clearable
                remote
                filterable
                multiple 
                collapse-tags
                :remote-method="remoteMethodStaff"
              >
                <el-option
                  v-for="item in options.nurse_id"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>      <!-- <el-form-item label="所属护理师" class="form-item">
                <el-cascader
                  v-model="filterForm.nurse_id"
                  placeholder="请选择员工"
                  collapse-tags
                  :options="options.personList"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'children', 
                    emitPath: false,
                    multiple: true
                  }"
                  class="w220"
                  clearable
                ></el-cascader>
              </el-form-item> -->
            <el-form-item label="所属门店" class="form-item">
              <el-select
                v-model="filterForm.shop_id"
                placeholder="请选择门店"
                class="w220"
                clearable
                remote
                filterable
                multiple 
                collapse-tags
              >
                <el-option
                  v-for="item in options.shopList" 
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="所属市场" class="form-item">
              <el-select
                v-model="filterForm.market_id"
                placeholder="请选择市场"
                class="w220"
                clearable
                remote
                filterable
                multiple 
                collapse-tags
              >
                <el-option
                  v-for="item in options.marketList" 
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="客户标签" class="form-item">
              <el-select v-model="filterForm.member_label" filterable multiple collapse-tags placeholder="请选择客户标签" class="w220" clearable>
                <el-option
                  v-for="item in options.memberLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户保有" class="form-item">
              <el-select v-model="filterForm.baoyou" multiple collapse-tags placeholder="请选择客户保有等级" class="w220" clearable>
                <el-option
                  v-for="item in options.baoyouList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户流失" class="form-item">
              <el-select v-model="filterForm.liushi" multiple collapse-tags placeholder="请选择客户流失等级" class="w220" clearable>
                <el-option
                  v-for="item in options.baoyouList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="未进店时间" class="form-item">
              <el-date-picker
                v-model="filterForm.no_entry_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="w220"
              ></el-date-picker>
              <div class="form-tips">筛选在此时间段内未进店的客户</div>
            </el-form-item>
          </div>
          
          <div class="group">成交信息</div>
          <div class="form-container">
            <el-form-item label="成交时间" class="form-item">
              <el-date-picker
                v-model="filterForm.cj_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="w220"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="成交金额区间" class="form-item">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_cj_money"
                  placeholder="最小金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_cj_money"
                  placeholder="最大金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="订单类型" class="form-item">
              <el-select v-model="filterForm.order_type" placeholder="请选择订单类型" class="w220" multiple clearable>
                <el-option label="新单" :value="1"></el-option>
                <el-option label="补单" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务类型" class="form-item">
              <el-select
                v-model="filterForm.business_type"
                placeholder="请选择业务类型"
                class="w220"
                multiple
                clearable
                collapse-tags
              >
                <el-option label="疤痕" :value="1"></el-option>
                <el-option label="青春痘" :value="3"></el-option>
                <el-option label="项目" :value="2"></el-option>
                <el-option label="护肤品" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开单人" class="form-item">
              <el-select
                v-model="filterForm.operator_id"
                placeholder="请选择开单人"
                class="w220"
                clearable
                remote
                filterable
                multiple 
                collapse-tags
                :remote-method="remoteMethodStaff"
              >
                <el-option
                  v-for="item in options.nurse_id"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="未成交时间" class="form-item">
              <el-date-picker
                v-model="filterForm.no_deal_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="w220"
              ></el-date-picker>
              <div class="form-tips">筛选在此时间段内未成交的客户</div>
            </el-form-item>
          </div>
          
          <div class="group">消费信息</div>
          <div class="form-container">
            <el-form-item label="年度消费日期" class="form-item">
              <el-date-picker
                v-model="filterForm.year_time"
                type="year"
                class="w150"
                placeholder="请选择日期"
                value-format="yyyy" 
              ></el-date-picker>
            </el-form-item>
            
            <el-form-item label="门店年度消费金额" class="form-item">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_dian_year"
                  placeholder="最小金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_dian_year"
                  placeholder="最大金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="门诊年度消费金额" class="form-item">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_zhen_year"
                  placeholder="最小金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_zhen_year"
                  placeholder="最大金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="门店总消费金额" class="form-item">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_dian_all"
                  placeholder="最小金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_dian_all"
                  placeholder="最大金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="门诊总消费金额" class="form-item">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_zhen_all"
                  placeholder="最小金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_zhen_all"
                  placeholder="最大金额"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
              </div>
            </el-form-item>
          </div>
          
          <div class="group">品项/商品信息</div>
          <div class="form-container">
            <el-form-item label="已购类型" class="form-item">
              <el-select
                v-model="filterForm.order_item_type"
                placeholder="请选择类型"
                class="w220"
                clearable
                multiple 
              >
                <el-option
                  v-for="item in options.orderItemTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="卡项到期时间" class="form-item" v-if="filterForm.order_item_type.includes(3)">
              <el-date-picker
                v-model="filterForm.service_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="w220"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="卡项剩余次数" class="form-item" v-if="filterForm.order_item_type.includes(3)">
              <div class="age-range">
                <el-input
                  v-model="filterForm.min_service_num"
                  placeholder="最少次数"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
                <span class="range-separator">-</span>
                <el-input
                  v-model="filterForm.max_service_num"
                  placeholder="最多次数"
                  class="w100"
                  type="number"
                  min="0"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="已购服务" class="form-item" v-if="filterForm.order_item_type.includes(3)">
              <el-select
                v-model="filterForm.available_project"
                placeholder="请选择已购服务"
                class="w220"
                clearable
                filterable
                multiple 
                remote
              >
                <el-option
                  v-for="item in options.availableItems"
                  :key="item.kingdee_code"
                  :label="item.name"
                  :value="item.kingdee_code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="已购品项" class="form-item" v-if="filterForm.order_item_type.includes(1)">
              <el-select
                v-model="filterForm.available_item"
                placeholder="请选择已购品项"
                class="w220"
                clearable
                filterable
                multiple 
                remote
              >
                <el-option
                  v-for="item in options.availablePx"
                  :key="item.kingdee_code"
                  :label="item.name"
                  :value="item.kingdee_code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="已购商品" class="form-item" v-if="filterForm.order_item_type.includes(2)">
              <el-select
                v-model="filterForm.available_product"
                placeholder="请选择已购商品"
                class="w220"
                clearable
                filterable
                multiple 
                remote
              >
                <el-option
                  v-for="item in options.availableSp"
                  :key="item.kingdee_code"
                  :label="item.name"
                  :value="item.kingdee_code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      
      <div class="drawer-footer">
        <el-button @click="cancelDrawer" size="mini">取消</el-button>
        <el-button type="primary" @click="saveFilter" size="mini">保存筛选</el-button>
        <el-button @click="resetForm" size="mini">重置</el-button>
      </div>
    </el-drawer>
    
    <el-dialog
      title="分群保存"
      width="500px"
      :visible.sync="dialogVisible"
       :close-on-click-modal="false"
    >
    <div style="height: 150px;">
      <el-form label-width="80px" ref="filterFormRef"  :model="filterForm">
        <el-form-item label="名称">
          <el-input
            v-model="filterForm.search_name"
            placeholder="请输入名称"
            class="w220"
            size="mini"
            clearable
          />
        </el-form-item>
        <el-form-item label="权限">
          <el-select v-model="filterForm.type" placeholder="请选择" size="mini" class="w100">
            <el-option :value="1" label="按市场" v-if="admin_level == 3"></el-option>
            <el-option :value="2" label="按店铺" v-if="admin_level == 3 || admin_level == 2"></el-option>
            <el-option :value="3" label="按员工" v-if="admin_level == 3 || admin_level == 2 || (admin_level == 1 && userInfo.position_id <= 7)"></el-option>
            <el-option :value="4" label="个人" ></el-option>
          </el-select>
              
          <el-select  
            v-if="filterForm.type == 1" 
            :key="'market-select-' + selectKey" 
            v-model="filterForm.market" 
            collapse-tags 
            multiple 
            placeholder="请选择市场"
            class="w220"
            size="mini"
          >
            <el-option
              v-for="item in options.marketList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select  
            v-if="filterForm.type == 2" 
            :key="'shop-select-' + selectKey" 
            v-model="filterForm.shop" 
            collapse-tags 
            multiple 
            size="mini"
            placeholder="请选择店铺"
            class="w220"
          >
            <el-option
              v-for="item in options.shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-cascader  
            v-if="filterForm.type == 3"
            :key="'person-select-' + selectKey"
            v-model="filterForm.person"
            placeholder="请选择员工"
            collapse-tags
            size="mini"
            :options="options.personList"
            :props="{
              value: 'id',
              label: 'name',
              children: 'children', 
              emitPath: false,
              multiple: true
            }"
            class="w220"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
    </div>
      
      <div class="drawer-footer">
        <el-button @click="closeDialog" size="mini">取消</el-button>
        <el-button @click="addSubmit" type="primary" size="mini">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/Pagination";
import {
  getGroupList,
  ssettingList,
  getGradeList,
  getTwoLabel,
  addSearchGroup,
  delSearchGroup,
  scarSetting,
  adminList,
  clientExport1
} from "@/api/client";
import {  shopPerson } from "@/api/shop";
import { getGoodList } from '@/api/goods'
import { getStore } from "@/utils/store";
import { getStaffList } from "@/api/staff";

class Options {
  personList = [];
  personsList = [];
  shopList = [];
  marketList = [];
  sourceIdList = [];
  source_type_id = [];
  effective_entry = [
    { id: 0, name: "全部" },
    { id: 1, name: "是" },
    { id: 2, name: "否" }
  ];
  membershipLeveList = [];
  memberLabelList = [];
  nurse_id = [];
  member_classification = [];
  repairProgressList = [];
  type_id = [];
  adminList = [];
  position_id = [];
  baoyouList = [
    {id:'A',name:'A级'},
    {id:'B',name:'B级'},
    {id:'C',name:'C级'},
    {id:'D',name:'D级'},
    {id:'E',name:'E级'},
  ];
  difficultyLevelList = [
    {id:1,name:'1级'},
    {id:2,name:'2级'},
    {id:3,name:'3级'},
    {id:4,name:'4级'},
    {id:5,name:'5级'},
  ];
  orderItemTypes = [
    {id:1,name:'品项'},
    {id:2,name:'商品'},
    {id:3,name:'服务'}
  ];
  scarTypeList = [];
  availablePx = [];
  availableSp = [];
  availableItems = [];
}

class Search {
  type = "";
}

class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}

export default {
  name: "ClientList",
  components: {
    pagination
  },
  data() {
    return {
      admin_level: getStore('admin_level'),
      search: new Search(),
      options: new Options(),
      page: new Page(),
      list: [],
      idList: "",
      loading: false,
      dialogVisible: false,
      isShowBalance: false,
      selectKey: 0,
      addDialogVisible: false,
      filterForm: {
        // 权限范围
        type: "",
        market: [],
        shop: [],
        person: [],
        search_name: "",
        // 基础信息
        create_time: [],        // 创建时间
        customer_name: "",      // 客户姓名
        telephone: "",          // 手机号
        king_no: "",            // 金蝶编码
        sex: "",                // 性别
        min_age: null,          // 修复：数字字段初始值为null
        max_age: null,          // 修复：数字字段初始值为null
        source_id: [],          // 渠道来源
        entry_time: [],         // 到店时间
        difficulty_level: [],   // 修复：多选字段初始值为数组
        scar_id: [],            // 疤痕类型
        repair_progress: [],    // 修复：多选字段初始值为数组
        membership_leve: "",       // 修复：单选字段初始值为字符串
        creator_id: "",         // 客服
        nurse_id: [],           // 护理师
        shop_id: [],            // 门店
        market_id: [],          // 市场
        member_label: [],      // 修复：多选字段初始值为数组
        baoyou: [],             // 修复：多选字段初始值为数组
        liushi: [],             // 修复：多选字段初始值为数组
        no_entry_time: [],      // 未进店时间
        // 成交信息
        cj_time: [],            // 成交时间
        min_cj_money: null,     // 修复：数字字段初始值为null
        max_cj_money: null,     // 修复：数字字段初始值为null
        order_type: [],         // 订单类型
        business_type: [],      // 业务类型
        operator_id: [],        // 开单人
        no_deal_time: [],       // 未成交时间
        // 消费信息
        year_time: "",          // 年度消费日期
        min_dian_year: null,    // 修复：数字字段初始值为null
        max_dian_year: null,    // 修复：数字字段初始值为null
        min_zhen_year: null,    // 修复：数字字段初始值为null
        max_zhen_year: null,    // 修复：数字字段初始值为null
        min_dian_all: null,     // 修复：数字字段初始值为null
        max_dian_all: null,     // 修复：数字字段初始值为null
        min_zhen_all: null,     // 修复：数字字段初始值为null
        max_zhen_all: null,     // 修复：数字字段初始值为null
        // 品项/商品信息
        order_item_type: [],    // 开单项目
        service_time: [],       // 卡项到期时间
        min_service_num: null,  // 修复：数字字段初始值为null
        max_service_num: null,  // 修复：数字字段初始值为null
        available_project: [],  // 修复：多选字段初始值为数组
        available_item: [],     // 修复：多选字段初始值为数组
        available_product: []   // 修复：多选字段初始值为数组
      }
    };
  },
  watch: {
    'filterForm.type'(newVal) {
      this.filterForm.market = [];
      this.filterForm.shop = [];
      this.filterForm.person = [];
      this.selectKey++;
      
      if ([1, 2, 3].includes(newVal)) {
        this.$nextTick(() => {
          this.shopPersonList();
        });
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.getList();
  },
  methods: {
    getExport(row) {
      clientExport1({ ...row.search_content, search_id:row.id,admin_id:this.userInfo.id }).then(res => {
        window.open(res.data.url);
      });
    },
    remoteMethodStaff(e) {
      getStaffList({ page: 1, limit: 100000, staffName: e }).then(res => {
        this.options.nurse_id = res.list;
      });
    },
    deleteTag(row){
      delSearchGroup({id: row.id, delete_id: this.userInfo.id}).then(res => {
        if(res.code == 200){
          this.$message.success('删除成功');
          this.getList();
        }else{
          this.$message.error(res.msg || '删除失败');
        }
      }).catch(error => {
        this.$message.error('删除失败');
      });
    },
    shopPersonList(){  
      adminList().then(res => {
        this.options.adminList = res || [];
      })
      shopPerson({action: 'market'}).then(res => {
        this.options.marketList = res || [];
      })
      shopPerson({action: 'shop'}).then(res => {
        this.options.shopList = res || [];
      })
      shopPerson({action: 'person'}).then(res => {
        this.options.personList = res || [];
      })
      this.$nextTick(() => {
        this.selectKey++;
      });
    },
    getOptions() {
      this.shopPersonList();  
      scarSetting().then(res => {
        this.options.scarTypeList = res;
      });
      getGradeList().then(res => {
        this.options.membershipLeveList = res.list;
      });
      getTwoLabel().then(res => {
        this.options.memberLabelList = res.data;
      });
      getGoodList({ type:1, shop_id:this.userInfo.shop_id,action:'search'}).then(res=>{
        this.options.availablePx = res;
      })
      getGoodList({ type:2,action:'search'}).then(res=>{
        this.options.availableSp = res;
      })
      getGoodList({ type:3,action:'search'}).then(res=>{
        this.options.availableItems = res;
      })
      ssettingList({ page: 1, limit: 100000 }).then(res => {
        let that = this;
        res.list.forEach(function(item) {
          if (item.category_id == 1) {
            that.options.type_id.push(item);
          } else if (item.category_id == 2) {
            that.options.position_id.push(item);
          } else if (item.category_id == 4) {
            that.options.sourceIdList.push(item);
          } else if (item.category_id == 5) {
            that.options.repairProgressList.push(item);
          } else if (item.category_id == 8) {
            that.options.member_classification.push(item);
          } else if (item.category_id == 15) {
            that.options.source_type_id.push(item);
          }
        });
      });
    },
    getList(option) {
      this.loading = true;
      if (option === "search") {
        this.page = new Page();
      }
      getGroupList({ 
        ...this.search, 
        ...this.page, 
        admin_user: this.userInfo.id 
      }).then(res => {
        this.list = res.list || [];
        this.page.total = res.total || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error('获取列表失败');
      });
    },
    tapBtn(routerName, row) {
      if(routerName == '查看'){
        let query = {id:row.id}
        let route = this.$router.resolve({ name: '符合客户列表', query: query});
        window.open(route.href, '_blank');
      } 
    },
    showAddDialog() {
      this.addDialogVisible = true;
      this.getOptions();
      this.resetForm();
    },
    handleDrawerClose(done) {
      this.cancelDrawer();
      done();
    },
    cancelDrawer() {
      this.addDialogVisible = false;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    addSubmit(){
      if (!this.filterForm.type  || !this.filterForm.search_name) {
        this.$message.warning("请填写筛选名称，选择权限");
        return;
      }
      if((this.filterForm.type == 1 && this.filterForm.market.length == 0) || (this.filterForm.type == 2 && this.filterForm.shop.length == 0) || (this.filterForm.type == 3 && this.filterForm.person.length == 0)){
        this.$message.warning("请选择权限范围");
        return;
      }
      
      const filterData = {
        type: this.filterForm.type,
        market: this.filterForm.market ? this.filterForm.market.join(','):'',
        shop: this.filterForm.shop ? this.filterForm.shop.join(','):'',
        person: this.filterForm.person ? this.filterForm.person.join(','):'',
        search_name: this.filterForm.search_name,
        admin_id: this.userInfo.id,
        search_content: {
          create_start: this.filterForm.create_time[0] || '',
          create_end: this.filterForm.create_time[1] || '',
          customer_name: this.filterForm.customer_name,
          telephone: this.filterForm.telephone,
          king_no: this.filterForm.king_no,
          sex: this.filterForm.sex,
          min_age: this.filterForm.min_age,
          max_age: this.filterForm.max_age,
          source_id: this.filterForm.source_id,
          entry_start: this.filterForm.entry_time[0] || '',
          entry_end: this.filterForm.entry_time[1] || '',
          difficulty_level: this.filterForm.difficulty_level,
          scar_id: this.filterForm.scar_id,
          repair_progress: this.filterForm.repair_progress,
          membership_leve: this.filterForm.membership_leve,
          creator_id: this.filterForm.creator_id,
          nurse_id: this.filterForm.nurse_id,
          shop_id: this.filterForm.shop_id,
          market_id: this.filterForm.market_id,
          member_label: this.filterForm.member_label,
          baoyou: this.filterForm.baoyou,
          liushi: this.filterForm.liushi,
          no_entry_start: this.filterForm.no_entry_time[0] || '',
          no_entry_end: this.filterForm.no_entry_time[1] || '',
          // 成交信息
          cj_time_start: this.filterForm.cj_time[0] || '',
          cj_time_end: this.filterForm.cj_time[1] || '',
          min_cj_money: this.filterForm.min_cj_money,
          max_cj_money: this.filterForm.max_cj_money,
          order_type: this.filterForm.order_type,
          business_type: this.filterForm.business_type,
          operator_id: this.filterForm.operator_id,
          no_deal_start: this.filterForm.no_deal_time[0] || '',
          no_deal_end: this.filterForm.no_deal_time[1] || '',
          // 消费信息
          year_time: this.filterForm.year_time,
          min_dian_year: this.filterForm.min_dian_year,
          max_dian_year: this.filterForm.max_dian_year,
          min_zhen_year: this.filterForm.min_zhen_year,
          max_zhen_year: this.filterForm.max_zhen_year,
          min_dian_all: this.filterForm.min_dian_all,
          max_dian_all: this.filterForm.max_dian_all,
          min_zhen_all: this.filterForm.min_zhen_all,
          max_zhen_all: this.filterForm.max_zhen_all,
          // 品项/商品信息
          order_item_type: this.filterForm.order_item_type,
          service_start: this.filterForm.service_time[0] || '',
          service_end: this.filterForm.service_time[1] || '',
          min_service_num: this.filterForm.min_service_num,
          max_service_num: this.filterForm.max_service_num,
          available_project: this.filterForm.available_project,
          available_item: this.filterForm.available_item,
          available_product: this.filterForm.available_product,
          kingdee_code: [...this.filterForm.available_product,...this.filterForm.available_item,...this.filterForm.available_project],
        }
      };
      
      addSearchGroup(filterData).then(res => {
        if (res.code === 200) {
          this.$message.success("筛选条件已保存");
          this.dialogVisible = false;
          this.addDialogVisible = false;
          this.getList('search');
        } else {
          this.$message.error(res.msg || "保存筛选条件失败");
        }
      }).catch(error => {
        console.error('保存失败：', error);
      });
    },
    saveFilter() {
      const filterFields = [
        'min_dian_year', 'max_dian_year',
        'min_zhen_year', 'max_zhen_year',
        'min_dian_all', 'max_dian_all',
        'min_zhen_all', 'max_zhen_all'
      ];
      const hasFilterValue = filterFields.some(field => {
        const value = this.filterForm[field];
        return value !== undefined && value !== null && value !== '';
      });
      if (hasFilterValue && !this.filterForm.year_time) {
        this.$message.warning("请选择年度消费日期");
        return;
      }
      this.addDialogVisible = false;
      this.dialogVisible = true;
    },
    resetForm() {
      if (this.$refs.filterFormRef) {
        this.$refs.filterFormRef.resetFields();
      }
      Object.keys(this.filterForm).forEach(key => {
        if (Array.isArray(this.filterForm[key])) {
          this.filterForm[key] = [];
        } else if (typeof this.filterForm[key] === 'number') {
          this.filterForm[key] = null;
        } else {
          this.filterForm[key] = "";
        }
      });
      this.selectKey = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.mainColor {
  color: #2dc0a3;
}
.content {
  height: calc(100% - 56px);
  overflow-y: auto;
}
.bgW {
  background: #fff;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 20px;
}

.el-form-item {
  margin: 5px 20px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 0px 10px 80px;
  .btnBox {
    display: flex;
    justify-content: end;
  }
}

.drawer-content {
  padding: 20px;
  height: calc(100% - 70px);
  overflow-y: auto;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.group{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left: 3px solid #33bea7;
  padding-left: 8px;
  line-height: 1;
  margin-bottom: 14px
}
.form-container {
  max-height: 600px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  align-items: center;
}

.form-item {
  margin-bottom: 15px;
  width: 30%;
  ::v-deep .el-form-item__label {
    text-align: right;
    padding-right: 10px;
  }
}
.form-item1 {
  width: 60%;
  ::v-deep .el-form-item__label {
    text-align: right;
    padding-right: 10px;
  }
}

.form-item-full {
  flex: 0 0 100%;
  min-width: 100%;
}

.age-range {
  display: flex;
  align-items: center;
  
  .range-separator {
    margin: 0 10px;
    color: #666;
  }
}
.w80 {
  width: 80px;
}
.w150 {
  width: 150px;
}
.w220 {
  width: 220px;
  min-width: 220px;
}
.form-tips {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.theme {
  color: #2dc0a3;
  cursor: pointer;
  padding: 0 8px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

::v-deep .el-drawer__header {
  margin-bottom: 0;
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
  
  span {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
}

::v-deep .el-drawer__body {
  padding: 0;
  overflow: hidden;
}

::v-deep .el-drawer.ltr {
  width: 90% !important;
  max-width: 1200px;
}

@media (max-width: 768px) {
  ::v-deep .el-drawer.ltr {
    width: 100% !important;
  }
  
  .form-item {
    flex: 0 0 100%;
  }
}

::v-deep .el-form-item__content {
  .w100 {
    margin-right: 10px;
  }
  
  .w220 {
    flex: 1;
  }
}
</style>